var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 54770",
    clipPath: "url(#clip0_420_5340)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 34.5,
    width: 11,
    height: 80,
    fill: "#05FF00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 80,
    y: 34.5,
    width: 11,
    height: 80,
    transform: "rotate(90 80 34.5)",
    fill: "#05FF00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 54769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1_2",
    x: 64.3955,
    y: 7.82664,
    width: 11,
    height: 80,
    transform: "rotate(45 64.3955 7.82664)",
    fill: "#05FF00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2_2",
    x: 72.1738,
    y: 64.3952,
    width: 11,
    height: 80,
    transform: "rotate(135 72.1738 64.3952)",
    fill: "#05FF00"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_420_5340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement);
export default __webpack_public_path__ + "static/media/element.5bc72a70c29031d0e97da919e08139b4.svg";
export { ForwardRef as ReactComponent };